import { Container } from "@mui/material";

export const PrivacyPolicy = () => {
  return (
    <Container style={{ marginTop: "2rem" }}>
      <h1 className="nhsuk-heading-xl">Privacy Policy</h1>
      <p className="nhsuk-body">
        Type of website: A pilot system to collect data from patients and
        relatives to support assessment and monitoring for mental health and
        neurodevelopmental conditions.
      </p>
      <p className="nhsuk-body">Effective date: 1st day of June, 2024</p>
      <p className="nhsuk-body">
        https://www.mentalhealthonline.co.uk/ (the "Site") is owned and operated
        by Red Star AI Ltd. Red Star AI Ltd is the data processor and can be
        contacted at:
        <br /><br/>
        support@redstar.ai
        <br /><br/>
        NHS Greater Glasgow & Clyde (NHS GGC) is the data controller and can be
        contacted at:
        <br /><br/>
        Health Records Legal Manager
        <br />
        NHS Greater Glasgow and Clyde
        <br />
        Admin Building Level 2<br />
        Gartnavel Royal Hospital
        <br />
        1055 Great Western Road
        <br />
        Glasgow
        <br />
        G12 0XH
        <br />
        Email: ggc.legalaspectsnorth@nhs.scot
        <br />
        Call: 0141 211 3855
      </p>
      <p className="nhsuk-body">
        www.mentalhealthonline.co.uk site is used to collect data from patients
        and partners/relatives (ADHD only) to support a wider clinical system
        provided by Red Star. The NHS clinical system stores additional data on
        patients taken from NHS records to support the assessment and monitoring
        of patients.
      </p>
      <h2 className="nhsuk-heading-l">Purpose</h2>
      <p className="nhsuk-body">
        The purpose of this privacy policy (this "Privacy Policy") is to inform
        users of our Site of the following:<br/><br/>
      1. The personal data we will collect;
      <br />
      2. Use of collected data;
      <br />
      3. Who has access to the data collected; and
      <br />
      4. The rights of Site users.
      </p>
      <p className="nhsuk-body">
        This Privacy Policy applies in addition to the terms and conditions of
        our Site.
      </p>
      <h2 className="nhsuk-heading-l">GDPR</h2>
      <p className="nhsuk-body">
        For users in the European Union, we adhere to the Regulation (EU)
        2016/679 of the European Parliament and of the Council of 27 April 2016,
        known as the General Data Protection Regulation (the "GDPR"). For users
        in the United Kingdom, we adhere to the GDPR as enshrined in the Data
        Protection Act 2018.
      </p>
      <h2 className="nhsuk-heading-l">Consent</h2>
      <p className="nhsuk-body">
        By using our Site users agree that they consent to:
        <br />
        1. The conditions set out in this Privacy Policy.
      </p>
      <h2 className="nhsuk-heading-l">Legal Basis for Processing</h2>
      <p className="nhsuk-body">
        We collect and process personal data about users in the EU only when we
        have a legal basis for doing so under Article 6 of the GDPR.
      </p>
      <p className="nhsuk-body">
        We rely on the following legal basis to collect and process the personal
        data of users in the EU:
        <br />
        1. Processing of user personal data is necessary to a task carried out
        in the public interest or in the exercise of our official authority.
      </p>
      <h2 className="nhsuk-heading-l">Personal Data We Collect</h2>
      <p className="nhsuk-body">
        We only collect data that helps us achieve the purpose set out in this
        Privacy Policy. We will not collect any additional data beyond the data
        listed below without notifying you first.
      </p>
      <h2 className="nhsuk-heading-m">Data Collected in a Non-Automatic Way</h2>
      <p className="nhsuk-body">
        We may also collect the following data when you perform certain
        functions on our Site:
        <br /><br/>
        1. First and last name;
        <br />
        2. Email address;
        <br />
        3. Phone number;
        <br />
        4. Eating disorders: Patient responses to standard psychological
        questionnaires and food diaries;
        <br />
        5. ADHD: Patient responses to ADHD psychological and medical monitoring
        <br />
        questionnaires; and
        <br />
        6. ADHD: Nominated relative and partner responses to information
        required to support the patient's diagnosis.
      </p>
      <p className="nhsuk-body">
        This data may be collected using the following methods:
        <br/><br/>
        1. Through online forms completed by users.
      </p>
      <h2 className="nhsuk-heading-m">How We Use Personal Data</h2>
      <p className="nhsuk-body">
        Data collected on our Site will only be used for the purposes specified
        in this Privacy Policy or indicated on the relevant pages of our Site.
        We will not use your data beyond what we disclose in this Privacy
        Policy.
      </p>
      <p className="nhsuk-body">
        The data we collect when the user performs certain functions may be used
        for the following purposes:
        <br />
        <br />
        1. Eating disorders: For the initial assessment and ongoing monitoring
        of people with eating disorders; and
        <br />
        2. ADHD: For the initial assessment and ongoing monitoring of people
        with ADHD.
        <br /><br/>
        <strong>
          Note that this site is used to collect data from Patients and
          nominated partner and relatives (ADHD only) to support clinical
          activities carried out by NHS Greater Glasgow & Clyde. All assessments
          and monitoring are performed by NHS GGC.
        </strong>
      </p>
      <h2 className="nhsuk-heading-m">Who We Share Personal Data With</h2>
      <p className="nhsuk-body">
        <u>Employees</u>
        <br />
        We may disclose user data to any member of our organisation who
        reasonably needs access to user data to achieve the purposes set out in
        this Privacy Policy.
      </p>
      <p className="nhsuk-body">
        <u>Third Parties</u>
        <br />
        We may share user data with the following third parties:
        <br />
        <br />
        1. Staff at NHS Greater Glasgow & Clyde (NHS GGC).
        <br />
        2. Gov.uk notify (https://www.notifications.service.gov.uk/)
        <br />
        <br />
        The following data is shared with NHS GGC:
        <br />
        1. All data entered by users through forms on the site.
        <br />
        <br />
        The following data is shared with Gov.uk notify:
        <br />
        <br />
        1. Email addresses
        <br />
        2. Phone numbers
        <br />
        <br />
        We may share user data with NHS GGC for the following purposes:
        <br /><br/>
        1. To support the diagnosis and ongoing monitoring of people with mental
        health and neurodevelopmental conditions
      </p>
      <p className="nhsuk-body">
        We may share user data with Gov.uk notify for the following purposes:
        <br /><br/>
        1. To send invitations and reminders in relation to the service
        <br />
        2. To send emails and text messages to support logins to the service
        <br />
        <br />
        Third parties will not be able to access user data beyond what is
        reasonably necessary to achieve the given purpose.
      </p>
      <p className="nhsuk-body">
        <u>Other Disclosures</u>
        <br />
        We will not sell or share your data with other third parties, except in
        the following cases:
        <br />
        <br />
        1. If the law requires it;
        <br />
        2. If it is required for any legal proceeding;
        <br />
        3. To prove or protect our legal rights; and
        <br />
        4. To buyers or potential buyers of this company in the event that we
        seek to sell the company.
        <br />
        <br />
        If you follow hyperlinks from our Site to another Site, please note that
        we are not responsible for and have no control over their privacy
        policies and practices.
      </p>
      <h2 className="nhsuk-heading-m">How Long We Store Personal Data</h2>
      <p className="nhsuk-body">
        User data will be stored until the purpose the data was collected for
        has been achieved. You will be notified if your data is kept for longer
        than this period.
      </p>
      <h2 className="nhsuk-heading-m">How We Protect Your Personal Data</h2>
      <p className="nhsuk-body">
        All data is encrypted on transit, requires a secure login to access, and
        our system has been security tested by experts
        <br />
        <br />
        While we take all reasonable precautions to ensure that user data is
        secure and that users are protected, there always remains the risk of
        harm. The Internet as a whole can be insecure at times and therefore we
        are unable to guarantee the security of user data beyond what is
        reasonably practical.
      </p>
      <h2 className="nhsuk-heading-m">Your Rights as a User</h2>
      <p className="nhsuk-body">
        Under the GDPR, you have the following rights:
        <br/><br/>
        1. Right to be informed;
        <br />
        2. Right of access;
        <br />
        3. Right to rectification;
        <br />
        4. Right to erasure;
        <br />
        5. Right to restrict processing;
        <br />
        6. Right to data portability; and 7. Right to object.
      </p>
      <h2 className="nhsuk-heading-l">Children</h2>
      <p className="nhsuk-body">
        The minimum age to use our website is 16 years of age. We do not
        knowingly collect or use personal data from children under 16 years of
        age. If we learn that we have collected personal data from a child under
        16 years of age, the personal data will be deleted as soon as possible.
        If a child under 16 years of age has provided us with personal data
        their parent or guardian may contact our data protection officer.{" "}
      </p>
      <h2 className="nhsuk-heading-l">
        How to Access, Modify, Delete, or Challenge the Data Collected
      </h2>
      <p className="nhsuk-body">
        If you would like to know if we have collected your personal data, how
        we have used your personal data, if we have disclosed your personal data
        and to who we disclosed your personal data, if you would like your data
        to be deleted or modified in any way, or if you would like to exercise
        any of your other rights under the GDPR, please contact our data
        protection officer here:
        <br />
        <br />
        Andrew Conkie
        <br />
        andrew.conkie@redstar.ai <br />
        ________________________________________
        <br />
        ________________________________________
        <br />
      </p>
      <h2 className="nhsuk-heading-l">Modifications</h2>
      <p className="nhsuk-body">
        This Privacy Policy may be amended from time to time in order to
        maintain compliance with the law and to reflect any changes to our data
        collection process. When we amend this Privacy Policy we will update the
        "Effective Date" at the top of this Privacy Policy. We recommend that
        our users periodically review our Privacy Policy to ensure that they are
        notified of any updates. If necessary, we may notify users by email of
        changes to this Privacy Policy.
      </p>
      <h2 className="nhsuk-heading-l">Complaints</h2>
      <p className="nhsuk-body">
        If you have any complaints about how we process your personal data,
        please contact us through the contact methods listed in the Contact
        Information section so that we can, where possible, resolve the issue.
        If you feel we have not addressed your concern in a satisfactory manner
        you may contact a supervisory authority. You also have the right to
        directly make a complaint to a supervisory authority. You can lodge a
        complaint with a supervisory authority by contacting the Information
        Commissioner's Office in the UK.
      </p>
      <h2 className="nhsuk-heading-l">Contact Information</h2>
      <p className="nhsuk-body">
        If you have any questions, concerns or complaints, you can
        contact our data protection officer, Andrew Conkie, at:
        <br />
        <br />
        andrew.conkie@redstar.ai
      </p>
    </Container>
  );
};
